export default __webpack_public_path__ + "static/media/mec-5.fa0493dc.png";